import { useStore } from 'src/contexts/StoreContext';
import { EditLookupToolbarProps } from '../EditLookupToolbar.types';
import { useMemo } from 'react';
import { ProductOptionModel } from 'src/store/_models/productOption';
import { EDIT_TOOLS } from '../../base-toolbar/BaseToolbar.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { getAvailableEditTool } from '../EditLookupToolbar.constants';
import { parseAnalyticsParamsByUserImageArea } from 'src/_shared/analytics.utils';

export const useRedoToolLogic = ({ onOpenTool, onCloseTool }: EditLookupToolbarProps) => {
  const {
    project: { activeUserImageArea },
  } = useStore();

  const canRedo = !!activeUserImageArea?.userImage?.canRedo;

  return useMemo(
    () => ({
      tool: ProductOptionModel.create({
        code: EDIT_TOOLS.redo,
      }),
      disabled: !canRedo,
      onOpenTool: async () => {
        canRedo && activeUserImageArea?.userImage?.redo();
        amplitude.trackEvent(
          AnalyticsEvents.modifyPhoto.restoreClick,
          parseAnalyticsParamsByUserImageArea(activeUserImageArea),
        );
        return {
          canBeSelected: false,
        };
      },
      onCloseTool,
      ToolOptionsRenderer: getAvailableEditTool(EDIT_TOOLS.redo)?.ToolOptionsRenderer,
    }),
    [onOpenTool, onCloseTool, canRedo, activeUserImageArea],
  );
};
